import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { changeAvatar } from '@store/reducers/manager/meta/actionCreators'
import { updateProjectCustomAvatar } from '@storeOld/reducers/auth'
import { put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

export function* reset() {
  const projectId: string = yield select(migrationProjectSelector.getProjectId)
  if (!projectId) {
    return
  }

  yield put(
    updateProjectCustomAvatar({
      avatar: null,
    })
  )

  yield put(
    changeAvatar({
      customAvatar: null,
      customAvatarFilename: null,
      projectId,
    })
  )
  sendGtmEvent(GtmTriggerName.PROJECT_UPLOAD_CUSTOM_LOGO)
}
